import React, { ReactNode } from 'react';

import { Box } from '@mui/material';

import { CopyToClipboard } from '../CopyToClipboard';

interface ICustomInlineStyles {
    [key: string]: string
}

interface IErrorHandlerProps {
    children?: ReactNode;
    component?: React.ElementType;
    display?: string;
    customInlineStyles?: ICustomInlineStyles;
    errorHeader?: string;
    errorMessage?: string;
    shouldShowCopyIcon?: boolean;
}

export const DEFAULT_ERROR_HANDLER_INLINE_STYLES = {
    color: 'error.main',
    fontSize: '12px',
    marginTop: '16px !important'
};

export const ErrorHandler: React.FC<IErrorHandlerProps> = ({
    children,
    component = 'div',
    display = 'inline',
    customInlineStyles = DEFAULT_ERROR_HANDLER_INLINE_STYLES,
    errorHeader,
    errorMessage,
    shouldShowCopyIcon = false
}) => {
    const defaultErrorContent = errorMessage;
    const copyToClipboardContent = children ? (
        <>
            <p style={{ fontSize: '14px' }}>{errorHeader}</p>
            <CopyToClipboard
                content={errorMessage ?? ''}
                clipboardInlineStyles={{ color: 'text.primary', cursor: 'pointer' }}
            />
            {children}
        </>
    ) : (
        <>
            <CopyToClipboard
                content={errorMessage ?? ''}
                clipboardInlineStyles={{ color: 'text.primary', cursor: 'pointer' }}
            />
            {errorMessage}
        </>
    );

    const errorContent = shouldShowCopyIcon ? copyToClipboardContent : defaultErrorContent;

    return (
        <Box
            component={component}
            display={display}
            sx={customInlineStyles}
        >
            {errorContent}
        </Box>
    );
};
